const COLLAPSIBLE_SECTION = {
  SECTION: "collapsible-section",
  HEADING: "collapsible-section-heading",
  CONTENT: "collapsible-section-content",
  SPAN: "collapsible-section-span",
};

const BANNER_IMAGE = {
  SECTION: "banner",
};

const STEPPER = {
  CONTAINER: "stepper-list",
};

const CUSTOM_TABLE = {
  CONTAINER: "sb-faq-table",
  BACKGROUND: "add-background",
  TABLE_TYPE: {
    VERTICAL: "vertical",
    HORIZONTAL: "horizontal",
  },
};

const TEMPLATES = {
  HOME: "Home",
  TOPIC: "Topic",
  SUB_TOPIC: "Sub-Topic",
  SECTION: "Section",
  FAQ: "FAQ",
};

const MODIFY_ELEMENT = {
  HIDE: "hide",
  FULL: "full",
  PARTIAL: "partial",
};

const ELEMENT = {
  ICON: "icon",
  TITLE: "title",
  HEADING: "heading",
  LIST: "list",
  SPAN: "span",
  CONTENT: "content",
  FEATURED_IMAGE: "featured-image",
  ITEM: "item",
  EXCERPT: "excerpt",
  CHILD_PAGE: "child-page",
  CHILD_PAGE_ID: "child-page-id",
};
const CLASSES = {
  MODIFY_ELEMENT,
  ELEMENT,
  COLLAPSIBLE_SECTION,
  BANNER_IMAGE,
  STEPPER,
  CUSTOM_TABLE,
};

const TEMPLATE_PATHS = {
  [TEMPLATES.HOME]: "./src/templates/Home/home.js",
  [TEMPLATES.TOPIC]: "./src/templates/Topic/topic.js",
  [TEMPLATES.SUB_TOPIC]:
    "./src/templates/SubTopic/subTopic.js",
  [TEMPLATES.SECTION]: null,
  [TEMPLATES.FAQ]: "./src/templates/FAQ/faq.js",
  [TEMPLATES.DEFAULT]: null,
};

const TEMPLATES_URI = {
  HOME: "/",
  EMPTY: "",
  DRAFT: /^\/..\/\?/,
  SEPERATOR: "/",
  SEARCH: "/search",
};

const PAGE_STATUS = {
  DRAFT: "draft",
  PUBLISH: "publish",
};

const OPEN_URL_ACTION_TYPE = {
  VIEW: "VIEW",
  CALL: "CALL",
};

const CONTACT_SUPPORT_STATUS = {
  YES: "Yes",
  NO: "No",
};

const isRunningOnBrowser = () =>
  typeof window !== "undefined";

const EVENTS = {
  CHATBOT_CLICKED: "CHATBOT_CLICKED",
  FAQ_LANDED: "FAQ_LANDED",
  FAQ_CLICKED: "FAQ_CLICKED",
  FEEDBACK_SURVEY_ANSWERED: "FEEDBACK_SURVEY_ANSWERED",
  REDIRECTING_FROM_FAQ_ORDERS:
    "REDIRECTING_FROM_FAQ_ORDERS",
  REDIRECTING_FROM_FAQ_FUNDS: "REDIRECTING_FROM_FAQ_FUNDS",
  FAQ_SEARCH_CLICKED: "FAQ_SEARCH_CLICKED",
  FAQ_SEARCH_RESULT_LOADED: "FAQ_SEARCH_RESULT_LOADED",
  FAQ_SEARCH_RESULT_CLICKED: "FAQ_SEARCH_RESULT_CLICKED",
  TALK_TO_US_CLICKED: "TALK_TO_US_CLICKED",
  HELP_CENTER_LOADED: "HELP_CENTER_LOADED",
  HELP_CENTER_VIEW_TICKET: "HELP_CENTER_VIEW_TICKET",
  FAQ_CATEGORY_CLICKED: "FAQ_CATEGORY_CLICKED",
  FAQ_SUBCATEGORY_CLICKED: "FAQ_SUBCATEGORY_CLICKED",
  FAQ_CATEGORY_LOADED: "FAQ_CATEGORY_LOADED",
  FAQ_SUBCATEGORY_LOADED: "FAQ_SUBCATEGORY_LOADED",
};

const CHATBOT_CONTEXT = {
  GLOBAL: "GLOBAL",
  LOCAL: "LOCAL",
};

const CTA_TYPES = {
  FUNDS_REDIRECTION: "funds",
  ORDERS_REDIRECTION: "orders",
};

const CTA_TYPES_EVENT_MAP = {
  [CTA_TYPES.FUNDS_REDIRECTION]:
    EVENTS.REDIRECTING_FROM_FAQ_FUNDS,
  [CTA_TYPES.ORDERS_REDIRECTION]:
    EVENTS.REDIRECTING_FROM_FAQ_ORDERS,
};

module.exports = {
  TEMPLATES,
  TEMPLATE_PATHS,
  CLASSES,
  TEMPLATES_URI,
  PAGE_STATUS,
  CONTACT_SUPPORT_STATUS,
  isRunningOnBrowser,
  EVENTS,
  OPEN_URL_ACTION_TYPE,
  CHATBOT_CONTEXT,
  CTA_TYPES_EVENT_MAP,
};
